import axios from "axios";
import { Apis } from "constants/apis";
import querystring from "querystring";
import { getToken } from "utils/token";
import { IReview } from "types/common";
import { string } from "yup";
interface IGetReview {
  reviews: IReview[];
  metadata: {
    is_first_page: boolean;
    is_last_page: boolean;
    current_page: number;
    total_reviews: number | string;
  };
}
const getReviews = async (payload: { [key: string]: any }): Promise<IGetReview> => {
  const params = querystring.stringify(
    Object.fromEntries(
      Object.entries(payload).filter(([key, value]) => !!value)
    )
  );
  const { data } = await axios.get(`user_reviews?${params}`, {
    headers: { Authorization: getToken() },
  });
  return data;
};

export default getReviews;
